<script>
    import { cubicOut } from 'svelte/easing';
    import { fade } from 'svelte/transition';
    import { createEventDispatcher } from 'svelte';

    export let active;

    const dispatch = createEventDispatcher();

    function closeMenu() {
        dispatch('closeMenu');
    }

    function logout() {
        dispatch('logout');
    }

    // Custom Slide Transition, because the default "fly" is pixel based and we sort of need it percentage based
    // X, Y and duration can be defined as needed
    function slidePercentageBased(node, { x = 0, y = 0, duration = 1000}) {
		return {
			duration,
            x,
            y,
			css: t => {
				const eased = cubicOut(t);

				return `
					transform: translateX(${(1-eased)*x}%) translateY(${(1-eased)*y}%);
                    `
			}
		};
	}
</script>

<!-- Shows on Wide Screens (>800px) -->
<!-- <div class="container-desktop">
    <nav class="menu menu-desktop">
        <header>
            <slot name="header">
                Menu header goes here
            </slot>
        </header>
        <div class="content">
            <slot name="content">
                Menu content goes here
            </slot>
        </div>
        <footer>
            <slot name="footer">
                Menu footer goes here
            </slot>
        </footer>
    </nav>
</div> -->

<!-- Shows on narrow Screens (<800px)-->
{#if active}
    <div class="container-mobile">
        <div class="overlay" transition:fade="{{ duration: 200 }}" on:click={closeMenu}></div>
        <nav class="menu menu-mobile" transition:slidePercentageBased="{{y: -100, duration: 200 }}">
            <div class="content">
                <slot name="content">
                    <!-- Menu content goes here -->
                </slot>
            </div>
        </nav>
    </div>
{/if}

<style>
    .container-desktop {
        width: 250px;
        height: 100vh;
        display: none;
        padding-top: 3rem;
    }

    .container-mobile {
        z-index: 1;
        display: block;
    }

    .overlay {
        position: fixed;
        left: 0;
        right: 0;
        top: 4rem;
        bottom: 0;
        background-color: black;
        opacity: 0.5;
        z-index: 2;
        /* backdrop-filter: blur(3px); */
    }

    .menu {
        color: white;
        background: #1A1A1A;
        display: flex;
        padding: 0;
        flex-direction: column;
    }
    
    .menu-desktop {
        width: 100%;
        height: 100%;
        box-sizing: border-box;
    }

    .menu-mobile {
        position: fixed;
        top: 4rem;
        bottom: 0;
        right: 0;
        left: 0;
        z-index: 2;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        /* border-radius: 0 0 1rem 1rem; */
        box-shadow: 0 0 20px rgba(0, 0, 0, 0.3);
        overflow: hidden;
    }

    header {
        height: 5rem;
        box-sizing: border-box;
        padding: 2rem;
        display: flex;
        align-items: center;
        font-weight: bold;
        width: 100%;
        max-width: 40rem;
        margin-right: auto;
        margin-left: auto;
    }

    .content {
        /* padding: 1.5rem; */
        flex-grow: 0;
        overflow-y: auto;
        width: 100%;
        max-width: 40rem;
        margin-right: auto;
        margin-left: auto;
        text-align: center;
    }

    footer {
        border-top: 1px solid black;
        width: 100%;
        max-width: 40rem;
        margin-right: auto;
        margin-left: auto;
        text-align: center;
    }

    /* @media only screen and (min-width: 800px) {
        .container-desktop {
            display: block;
        }

        .container-mobile {
            display: none;
        }
    } */
</style>